import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EnrollComponent } from './shared/components/enroll/enroll.component';
import { OopsComponent } from './shared/components/oops/oops.component';
import { AuthGuard } from './shared/services/auth.guard';
import { TokenGuard } from './shared/services/token.guard';
import { routesV3 } from './layout-v3/shared/const/routes-config';
import { V3IntegrationGuard } from './shared/guard/v3-integration.guard';
import { ActivateGuard } from './shared/guard/activate-guard';
import { LoginV3Component } from './layout-v3/login-v3/login-v3.component';
import { ErrorPageV3Component } from './layout-v3/shared/component/error-page-v3/error-page-v3.component';
import { ErrorPageGuard } from './shared/guard/error-page.guard';
import { MaintenanceProblemUiComponent } from './layout-v3/maintenance-problem-ui/maintenance-problem-ui.component';
import { LoginNycComponent } from './layout-v3/login-nyc/login-nyc.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: routesV3.cloudapps.route, pathMatch: 'full' },
      {
            path: routesV3.cloudapps.selector,
            canActivate: [V3IntegrationGuard, TokenGuard ],
            loadChildren: () => import('./layout-v3/layout-v3.module').then(m => m.LayoutV3Module)
      }, 
    ]
  },
  {
    path: 'enroll',
    component: EnrollComponent,
    data: {
      title: 'Enroll Chargify'
    },
    children: []
  },
  {
    path: 'signup/:token',
    loadChildren: () =>
      import('./signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'wizard/district/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./signup/signup-wizzard/signup-wizzard.module').then(
        m => m.SignupWizzardModule
      )
  },
  {
    path: routesV3.activate.selector,
    canActivate: [ActivateGuard],
    loadChildren: () =>
      import('./signup/signup-wizzard/signup-wizzard.module').then(
        m => m.SignupWizzardModule
      )
  },
  {
    path: 'wizard/district/:id/school/:schoolId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./signup/signup-wizzard/signup-wizzard.module').then(
        m => m.SignupWizzardModule
      )
  },
  {
    path: routesV3.login.selector,
    component: LoginV3Component,
  },
  {
    path: routesV3.loginnyc.selector,
    component: LoginNycComponent,
  },
  {
    path: routesV3.systemerror.selector,
    component: MaintenanceProblemUiComponent,
  },
  {
    path: 'legacy',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'resource/not-found',
    component: OopsComponent,
  },
  {
    path: routesV3.forbidden.selector,
    canActivate: [ErrorPageGuard],
    component: ErrorPageV3Component
  },
  {
    path: 'session/:vm',
    canActivate: [AuthGuard, TokenGuard],
    loadChildren: () =>
      import('src/app/istreamer/istreamer.module').then(
        m => m.IstreamerModule
      )
  },
  {
    path: 'session/admin/:vm',
    canActivate: [AuthGuard,TokenGuard],
    loadChildren: () =>
      import('src/app/istreamer/istreamer.module').then(
        m => m.IstreamerModule
      )
  },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
